import BaseApi from "./BaseApi";
import ApiHelper from "../helpers/ApiHelper";
import db from "../resources/db.json";

/**
 * 検索APIクラス
 *
 * @class SearchApi
 * @extends {BaseApi}
 */
class SearchApi extends BaseApi {
  /**
   * 指定されたパスでデータ検索をします
   *
   * @param {string} path パス
   * @param {object} search 検索条件
   * @param {number} page ページ数
   * @param {number} perPage 1ページ当たりの件数
   * @param {string} orderBy ソート対象のカラム
   * @param {string} order ソート方法（asc or desc）
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof SearchApi
   */
  async search(path, search = {}, page = 1, perPage, orderBy = "", order = "") {
    return { data: db[path.replace(/\//g, "")] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const formData = {
      page: Number(page),
      perPage: Number(perPage),
    };
    const searches = Object.entries(search).reduce((acc, field) => {
      acc[field[0]] = field[1];
      return acc;
    }, {});
    Object.keys(searches).forEach((key) => {
      if (searches[key]) {
        formData[`search[${key}]`] = searches[key];
      }
    });
    if (order && orderBy) {
      formData[`orderBy[${orderBy}]`] = order;
    }

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(path, { params: formData }),
    );
  }
}

export default SearchApi;
